/**
 * Isophi portals
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

/**
 * * `class` - class * `individual` - individual
 */
export type ShipLogItemKindEnum = 'class' | 'individual';

export const ShipLogItemKindEnum = {
    Class: 'class' as ShipLogItemKindEnum,
    Individual: 'individual' as ShipLogItemKindEnum
};